module.exports = __webpack_public_path__ + "img/camparisodanahaufnahme.9015aae4.jpg";